import { SearchForm } from '@/components/ui/SearchForm';
import { event } from '@/lib/google-analytics';
import { GA_ROUTING_MAP } from '@/lib/utils';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Fragment } from 'react';

export default function SearchFormDialog({
	isOpen,
	onClose,
	initialSearch = {},
}) {
	const router = useRouter();
	const { t } = useTranslation('common');
	const handleSearchDialogClose = () => {
		onClose();
		event('Search_Form_Modal', {
			category: GA_ROUTING_MAP[router.pathname],
			label: 'Closed',
		});
	};

	return (
		<Transition.Root show={isOpen} as={Fragment}>
			<Dialog
				as="div"
				className="relative z-2147483647"
				onClose={() => handleSearchDialogClose()}
			>
				<div className="fixed inset-0 bg-black/30" aria-hidden="true" />
				<div className="fixed inset-x-0 top-0 flex justify-center">
					<Transition.Child
						as={Fragment}
						enter="transform transition ease-in-out duration-500"
						enterFrom="translate-y-[-100%]"
						enterTo="translate-y-0"
						leave="transform transition ease-in-out duration-500"
						leaveFrom="translate-y-0"
						leaveTo="translate-y-[-100%]"
					>
						<Dialog.Panel className="w-full bg-white px-4 pb-4">
							<div className="p-4 lg:px-8 lg:pl-24">
								<div className="flex items-center justify-between">
									<Dialog.Title as="div">
										<h3 className="text-base font-semibold leading-6 text-gray-900">
											{t('labels.newSearch')}
										</h3>
									</Dialog.Title>
									<div className="ml-3 flex h-7 items-center">
										<button
											type="button"
											className="relative text-gray-900 hover:text-gray-500 focus:outline-hidden focus:ring-0 focus:ring-transparent"
											onClick={() => onClose()}
										>
											<span className="absolute -inset-2.5" />
											<span className="sr-only">Close panel</span>
											<XMarkIcon className="h-8 w-8" aria-hidden="true" />
										</button>
									</div>
								</div>
							</div>

							<SearchForm
								className="xl:pl-24"
								switchLocationsEnabled
								initialSearch={initialSearch}
								onSearch={handleSearchDialogClose}
							/>
						</Dialog.Panel>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition.Root>
	);
}
